<template>
  <div :class="['card', { 'bottom-margin' : isDetailedCard}]" :style="customHeight">
    <!-- NO ITEMPROP -->
    <div class="card-content" v-if="!isDetailedCard">
      <!-- Review Head Section Begin Desktop view -->
      <div class="media-content inner-review-card card-head">
        <figure class="media-left" v-if="!showBusinessAvatar">
          <!-- Normal Avatar -->
          <a :href="`/profile/${authorId}`">
            <avatar :src="review.authorAvatar" v-if="review.authorAvatar.length > 0"></avatar>
            <avatar :backgroundColor="authorAvatarColor"
                    :username="review.author" color="#ffffff"
                    v-if="authorAvatarColor.length > 0 && review.authorAvatar.length === 0"></avatar>
            <avatar :username="review.author"
                    v-if="authorAvatarColor.length === 0 && review.authorAvatar.length === 0"></avatar>
          </a>
        </figure>
        <figure class="media-left" v-if="showBusinessAvatar">
          <!-- Business Logo for avatar -->
          <a :href="`/${review.business_slug}`"><img :src="getBusinessLogo" alt="Business logo" class="image"/></a>
        </figure>
        <h1 v-if="showBusiness"><a :href="`/${review.business_slug}`" v-html="review.business_name"></a></h1>
        <p class="nps-rating is-desktop is-hidden-mobile"
           v-if="showRateBtn && !review.nps_rating && review.nps_rating != 0">
          <a @click.prevent="submitNpsRating" class="button is-outlined has-icons-left">RATE BUSINESS</a>
        </p>
      </div>
      <!-- Review Head Section End Desktop view -->
      <hr>
      <!-- Review Rating Begin -->
      <div class="author">
        <rating :review-card="compress" :stars="review.review_rating"
                class="card-rating is-desktop is-hidden-mobile is-hidden-tablet-only"></rating>
        <rating :review-card="compress" :stars="review.review_rating"
                class="card-rating is-mobile is-hidden-desktop is-12"></rating>
        <span class="is-pulled-right">{{ review.created_at | formattedDateAndTime }}</span>
      </div>
      <!-- Review Rating End -->
      <!-- Review Description Begin -->
      <div class="media-content">
        <div class="blurb">
          <p><a :href="`/${review.business_slug}/reviews/${review.permalink}`" v-html="review.review_content"></a></p>
        </div>
        <review-attachments :attachments="review.attachments"></review-attachments>
      </div>
      <!-- Review Description End -->
      <hr>
      <!-- Review Action Begin -->
      <div class="review-action-section">
        <span v-if="!review.messages.length"><i class="fas fa-comment-slash"></i> Business has not replied</span>
        <span v-else><i class="fas fa-comment"></i> {{review.messages.length}} {{ review.messages.length === 1 ? 'reply' : 'replies' }}</span>
        <span class="is-pulled-right" v-if="isReviewOwner">
          <div class="delete-block">
            <i @click.prevent="showDropDown = !showDropDown" class="fas fa-ellipsis-h is-pulled-right three-dot"></i>
            <transition v-if="showDropDown">
              <a
                @click="handleDropdown({task: 'handleDeleteReview', reviewId: review.id, reviewIndex: reviewIndex, reviewPermalink: review.permalink})"
                class="delete-reply button is-button-blue is-button-small is-pulled-right">Delete</a>
            </transition>
          </div>
        </span>
      </div>
      <!-- Review Action End -->
      <!-- Rate Business button for other than desktop Begin -->
      <p class="nps-rating is-hidden-desktop is-hidden-tablet is-mobile is-full"
         v-if="showRateBtn && !review.nps_rating && review.nps_rating != 0">
        <a @click.prevent="submitNpsRating" class="button is-outlined has-icons-left">RATE BUSINESS</a>
      </p>
      <!-- Rate Business button for other than desktop End -->
    </div>
  </div>
</template>
<script>
  import Avatar from 'vue-avatar'
  import moment from 'moment'
  import Rating from '@/components/Rating'
  import misc from '../mixins/misc.js'
  import ReviewAttachments from '@/components/ReviewAttachments'

  export default {
    name: 'ReviewCard',
    mixins: [misc],
    props: {
      reviewIndex: {
        type: Number
      },
      authorId: {
        type: String
      },
      authorAvatarColor: {
        type: String,
        default: ''
      },
      review: {
        type: Object
      },
      showBusiness: {
        type: Boolean,
        default: true
      },
      isDetailedCard: {
        type: Boolean,
        default: false
      },
      isThankYouCard: {
        type: Boolean,
        default: false
      },
      showBusinessAvatar: {
        type: Boolean,
        default: false
      },
      customHeight: {
        type: String,
        default: ''
      },
      showNPSRating: {
        type: Boolean,
        default: false
      },
      showRateBtn: {
        type: Boolean,
        default: false
      },
      showNPSScore: {
        type: Boolean,
        default: false
      }
    },
    components: {
      Avatar,
      Rating,
      ReviewAttachments
    },
    data() {
      return {
        compress: true,
        showDropDown: false
      }
    },
    created() {
      if (this.isDetailedCard) {
        window.events.$emit('review-detail-loaded', {
          author: this.author,
          reviewDate: this.review.created_at
        })
        window.events.$on('reportedReviewComplete', (data) => {
          flash(data.body, data.header)
          window.scrollTo(0, 0)
        })
      }
    },
    methods: {
      /**
       * Handling delete review
       * @param {object} obj
       * @return {void}
       */
      handleDropdown(obj) {
        this.showDropDown = false
        window.events.$emit(obj.task, obj)
      },
      submitNpsRating() {
        modal({
          'title': 'Rate Business',
          'show_btns': false,
          'show_cancel_btn': false,
          'show_close_btn': true,
          'task': 'npsRatingCallback',
          'setWidthAuto': false,
          'middleLarge': true,
          'isReportReview': false,
          'isUpdatePassword': false,
          'isNpsRating': true,
          'hide_submit_btn': true,
          'reviewSlug': this.review.permalink,
          'reviewPermalink': this.review.permalink,
          'business': this.review.business_name
        })
      }
    },
    computed: {
      /**
       * Checking if user is the very owner of review
       **/
      isReviewOwner() {
        return this.review.user_id === localStorage.getItem('profile_id')
      },
      /**
       * Getting the appropriate business logo
       **/
      getBusinessLogo() {
        if (this.review.business_logo !== null && this.review.business_logo.length > 0) {
          return this.review.business_logo
        } else if (this.review.industry_logo !== null && this.review.industry_logo.length > 0) {
          return `${this.review.industry_logo}`
        }
        const domain = process.env.APP_URL
        return `${domain}/static/img/hp-social-int-logo.svg`
      }
    },
    filters: {
      /**
       * Customising the date in format as (12 Sep 2015 at 18:09 pm)
       * @return {string}
       **/
      formattedDateAndTime(reviewDate) {
        return moment(reviewDate, 'YYYY-MM-DD HH:mm:ss').format('DD MMM YYYY [at] HH:mm a')
      }
    }
  }
</script>
<style scoped>
  .card {
    border: 1px solid #C9C9C9;
    box-shadow: none;
  }

  .card.bottom-margin {
    margin-bottom: 2rem;
  }

  a, a:hover, a:visited {
    text-decoration: none;
    color: #58595B;
  }

  .media-content {
    width: 100%;
  }

  .media-content.inner-review-card {
    overflow: hidden;
    width: 100%
  }

  .media-content > h1 {
    font-size: 1.0rem;
    font-weight: bold;
    margin-bottom: 0.5rem;
    width: 90%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .media-content > h2 {
    font-weight: bold;
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
    margin-right: 2rem;
    font-size: 1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .media-content > .is-detail-card {
    font-size: 1rem;
    font-weight: bold;
    width: 90%;
  }

  .media-content > .blurb {
    font-size: 0.9rem;
    overflow: hidden;
    position: relative;
    /* use this value to count block height */
    line-height: 1.4rem;
    /* max-height = line-height (1.2) * lines max number (3) */
    max-height: 4.2rem;
    /* fix problem when last visible word doesn't adjoin right side  */
    text-align: left;
    word-break: break-word;
    margin-top: 3%;
  }

  .media-content > .full-content {
    font-size: 0.9rem;
    line-height: 1.4rem;
    text-align: left;
    margin-right: 2rem;
    padding-right: 1rem;
    margin-top: 1.5rem;
    white-space: pre-wrap;
    word-break: break-word;
  }

  .media-content > .blurb:before {
    content: '...';
    position: absolute;
    right: 0;
    bottom: 0;
  }

  .media-content > .blurb:after {
    content: '';
    position: absolute;
    right: 0;
    width: 1em;
    height: 1em;
    margin-top: 0.2em;
    background: #ffffff;
  }

  .author {
    color: #8A8C91;
    font-size: 0.8rem;
    margin-top: 1.2rem;
  }

  .author a, .author a:hover, .author a:visited {
    text-decoration: none;
    color: #8A8C91;
  }

  .media-right > p {
    font-size: 1.4rem;
    margin-left: 1.4rem;
  }

  .media-left > a > .image {
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }

  .p-t-8 {
    padding-top: 8px;
  }

  .nps-rating a {
    border: 1px solid grey;
    border-radius: 0;
    padding: 1.3rem 2rem;
    font-size: 0.85rem;
  }

  /* Delete Reply CSS Begin */
  .three-dot {
    cursor: pointer;
  }

  .delete-reply {
    position: absolute;
    color: #000;
    background-color: #fff !important;
    border-color: #dbdbdb !important;
    border-radius: 0;
    margin-top: 12px;
    margin-right: -14px;
    right: 53px;
  }

  a.delete-reply {
    font-size: 13px;
    width: 80px;
    height: 38px;
  }

  a.delete-reply:hover {
    color: #000 !important;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .delete-block {
    padding-right: 15px;
  }

  /* Delete Reply CSS End */

  /*Review Card CSS Begin*/
  .card-head {
    display: flex;
    align-items: center;
  }

  .card-rating {
    display: inline-block;
  }

  .card-content > hr {
    background-color: #dbdbdb;
    border: none;
    height: 1.0px;
  }

  .review-action-section {
    font-size: 13px;
  }

  /*Review Card CSS End*/

  @media screen and (min-width: 768px) {
    .m-l-54 {
      margin-left: 54px;
    }
  }

  @media screen and (max-width: 767px) {
    .media-content > .blurb, .media-content > .full-content {
      margin-right: 1rem;
    }

    .card {
      border: none;
      border-top: 1px solid #C9C9C9;
    }

    .card.bottom-margin {
      margin-bottom: 0;
      border: none;
      border-bottom: 1px solid #C9C9C9;
    }

    .card.bottom-margin ~ .card {
      margin-bottom: 0;
      border: none;
      border-bottom: 1px solid #C9C9C9;
      margin-top: 0;
    }

    .is-review-details .card {
      margin-bottom: 0;
      margin-top: 0;
    }

    .is-review-details .card .media-left {
      display: none;
    }

    .card.bottom-margin ~ .card .media-left {
      display: none;
    }

    .card.bottom-margin .media-content {
      overflow: unset;
    }

    .card.bottom-margin .media-content, .card.bottom-margin .media-content > .is-detail-card, .card.bottom-margin .media-content > h1, .card.bottom-margin .media-content > h2 {
      width: 100%;
    }

    .card.bottom-margin .media-content > .full-content {
      margin-right: 0;
      padding-right: 0;
    }

    .nps-rating {
      position: relative;
      right: 0;
      top: 0;
      margin-top: 10%;
    }

    .nps-rating a {
      display: block;
      text-align: center;
      display: flex;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/UserProfileReviewCard.vue